import * as COMP from './images';

const Main = [
  { id: 0,
    name: 'Alerta Vermelho',
    image: COMP.alertavermelho,
    sinopse: 'No mundo do crime internacional, a INTERPOL lança um Alerta Vermelho, o que inicia uma caçada para capturar a mais notória ladra de artes do globo.',
    trailer: 'https://youtu.be/5JQuYpBZarc',
    imageCapa: COMP.alertavermelhocapa,
  },
  { id: 1,
    name: 'Não Olhe para Cima',
    image: COMP.naoolheparacima,
    sinopse: 'Dois astrônomos descobrem um cometa mortal vindo em direção à Terra e partem em um tour midiático para alertar a humanidade. Só que ninguém parece dar muita bola.',
    trailer: 'https://youtu.be/c1nToClX_3w',
    imageCapa: COMP.naoolheparacimacapa,
  },
  { id:16,
    name: 'The Rain',
    image: COMP.therain,
    sinopse: 'Seis anos após um vírus exterminar quase toda a população da Escandinávia, dois irmãos e um grupo de jovens sobreviventes partem em busca de segurança e de respostas.',
    trailer: 'https://youtu.be/Se3AfHO7GmY',
    imageCapa: COMP.theraincapa,
  },
  { id:29,
    name: 'Arcane',
    image: COMP.arcane,
    sinopse: 'Em meio ao conflito entre as cidades-gêmeas de Piltover e Zaun, duas irmãs lutam em lados opostos de uma guerra entre tecnologias mágicas e convicções incompatíveis.',
    trailer: 'https://youtu.be/3MB3OK3Xnvs',
    imageCapa: COMP.arcanecapa,
  },
  { id: 2,
    name: 'Imperdoável',
    image: COMP.imperdoavel,
    sinopse: 'Após cumprir pena por um crime violento, Ruth volta ao convívio na sociedade, que se recusa a perdoar seu passado. Discriminada no lugar que já chamou de lar, sua única esperança é encontrar a irmã, que ela havia sido forçada a deixar para trás.',
    trailer: 'https://youtu.be/P0RO1pF4L1o',
    imageCapa: COMP.imperdoavelcapa,
 },
 { id: 11,
  name: 'The House',
  image: COMP.thehouse,
  sinopse: 'Nesta comédia de animação de humor ácido, uma família humilde, um arquiteto ansioso e uma senhoria cansada ficam presos à mesma casa misteriosa em épocas diferentes.',
  trailer: 'https://www.youtube.com/watch?v=wqbZlAEUb5w',
  imageCapa: COMP.thehousecapa,
},
{ id:14,
  name: 'Emily em Paris',
  image: COMP.emilyemparis,
  sinopse: 'Emily Cooper consegue o trabalho dos sonhos em Paris. Agora, ela precisa administrar a carreira, os amigos e o amor na Cidade Luz.',
  trailer: 'https://youtu.be/d1sP0QTYWUo',
  imageCapa: COMP.emilyempariscapa,
},
  { id: 8,
    name: 'Exército de Ladrões: Invasão da Europa',
    image: COMP.exercitodeladroes,
    sinopse: 'Nesta história que antecede Army of the Dead, uma mulher misteriosa convida o caixa de banco Dieter para roubar cofres superprotegidos na Europa.',
    trailer: 'https://youtu.be/37dNU_rC6Gs',
    imageCapa: COMP.exercitodeladroescapa,
  },
  { id:23,
    name: 'Lupin',
    image: COMP.lupin,
    sinopse: 'Na adolescência, a vida de Assane Diop dá uma guinada radical quando seu pai morre após ser acusado de um crime que não cometeu. Vinte e cinco anos depois, Assane se inspira em "Arsène Lupin, o Ladrão de Casaca" para vingá-lo.',
    trailer: 'https://youtu.be/FoiQ-Xr8NDI',
    imageCapa: COMP.lupincapa,
  },
  { id: 10,
    name: 'O Preço do Amanhã',
    image: COMP.opreçodoamanha,
    sinopse: 'Acusado de assassinato, um homem deve descobrir como derrubar um sistema onde tempo é dinheiro e que permite que os ricos vivam para sempre, enquanto os pobres devem implorar por cada minuto de suas vidas.',
    trailer: 'https://youtu.be/XUSt9oZUTrs',
    imageCapa: COMP.opreçodoamanhacapa,
  },
  { id:13,
    name: 'La Casa de Papel',
    image: COMP.lacasadepapel,
    sinopse: 'Um homem misterioso que atende pelo nome de El Profesor, está planejando o maior assalto do século. A fim de realizar o ambicioso plano ele recruta uma gangue de oito pessoas com certas habilidades que não tem nada a perder. O objetivo é infiltrar na Casa da Moeda, de modo que eles possam imprimir 2,4 bilhões de euros. Para fazer isso eles precisam de onze dias de reclusão, durante o qual eles vão ter que lidar com sessenta e sete reféns e as forças da Polícia de Elite, com cenas de muita ação e planos brilhantes de El Profesor.',
    trailer: 'https://www.youtube.com/watch?v=fgS9vZJGcQQ',
    imageCapa: COMP.lacasadepapelcapa,
  },
  { id: 7,
    name: 'Escritores da Liberdade',
    image: COMP.ecritoresdaliberdade,
    sinopse: 'Uma jovem e idealista professora chega a uma escola de um bairro pobre, que está corrompida pela agressividade e violência. Os alunos se mostram rebeldes e sem vontade de aprender, e há entre eles uma constante tensão racial. Assim, para fazer com que os alunos aprendam e também falem mais de suas complicadas vidas, a professora Gruwell aposta em métodos diferentes de ensino. Aos poucos, os alunos vão retomando a confiança em si mesmos, aceitando mais o conhecimento e reconhecendo valores.',
    trailer: 'https://www.youtube.com/watch?v=pfwzLDj0yzM',
    imageCapa: COMP.escritoresdaliberdadecapa,
  },
  { id:15,
    name: 'Stranger Things',
    image: COMP.strangerthings,
    sinopse: 'Quando um garoto desaparece, a cidade toda participa nas buscas. Mas o que encontram são segredos, forças sobrenaturais e uma menina.',
    trailer: 'https://youtu.be/Yih1taiXm3Y',
    imageCapa: COMP.strangerthingscapa,
  },
  { id:25,
    name: 'Fate: A Saga Winx',
    image: COMP.winx,
    sinopse: 'Decididas a controlar seus poderes mágicos, cinco adolescentes encaram rivalidades, romances e estudos do mundo sobrenatural em uma escola para fadas.',
    trailer: 'https://youtu.be/FmyB6V4XgMk',
    imageCapa: COMP.winxcapa,
  },
  { id: 33,
    name: 'Ava',
    image: COMP.ava,
    sinopse: 'Atormentada por dúvidas, uma assassina de elite luta para proteger a si mesma e a sua família depois que uma missão dá errado.',
    trailer: 'https://youtu.be/Mot5ovqTPXo',
    imageCapa: COMP.avacapa,
  },
  { id:32,
    name: 'Anne With an "E',
    image: COMP.anne,
    sinopse: 'O mundo de Green Gables que Anne tanto adora se expande com novas pessoas e emocionantes histórias de amor, perdas e amadurecimento.',
    trailer: 'https://youtu.be/bBervTlBurY',
    imageCapa: COMP.annecapa,
  },
  { id: 36,
    name: 'Kate',
    image: COMP.kate,
    sinopse: 'Após ser envenenada de forma irreversível, uma assassina implacável tem menos de 24 horas para se vingar.',
    trailer: 'https://youtu.be/LtrS34nUGyQ',
    imageCapa: COMP.katecapa,
  },
  { id:12,
    name: 'The Witcher',
    image: COMP.thewicher,
    sinopse: 'O mutante Geralt de Rívia é um caçador de monstros que luta para encontrar seu lugar num mundo onde as pessoas muitas vezes são mais perversas que as criaturas selvagens.',
    trailer: 'https://youtu.be/tjujvMkqWe4',
    imageCapa: COMP.thewitchercapa,
  },
];

export default Main;
